
import {formaterOgTitle} from "~/helpers/formaterOgTitle";

export default {
  fetch: async function () {
    await this.getPage();
  },

  head: function () {
    const title = this.page.title;
    const description = `Заказывайте перевозки по Уралу. Различные виды грузоперевозок в городе ${this.page?.city?.name} с выгодными расценками. Осуществляются перевозки грузов транспортной компанией CentralTrans по РФ с гарантией качества`;

    return {
      title: title,
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(title, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
    }
  },
  data: function () {
    return {
      page: {},

      isLoading: true
    }
  },

  methods: {
    getPage: async function () {
      let slug = (this.$route?.path || "").slice(1);
      if (slug[slug.length - 1] === "/") {
        slug = slug.slice(0, -1);
      }
      const page = await this.$api.agent.transport.get(`/cargo-landing/get-by-slug?slug=${slug}`).then((res) => {
        return res.data
      }).catch(() => {
        return null
      });
      if (!page) {
        this.$nuxt.error({
          statusCode: 404
        })
        return
      }

      this.page = page;
      this.isLoading = false;
    },
  }
}
